import { addLevelAction, addProjectAction, updateProjectAction } from "../../../slice/project-detail";
import { getLevel } from "../../../actions/inventory.action";
import {
    getProject,
    getProgressClaimList,
    getPoCount,
    getWorkOrderCount,
    saveProjectType
} from "../../../actions/project-management.action";
import { getInvoiceList } from "../../../actions/invoice.action";
import { stageCalculation } from "../../../util/calculations";
import idx from "idx";
import { setCookie } from "../../../util/auth";


export const getOnlyProjectData = async ({ projectId, dispatch }) => {
    if (!projectId) return;

    setCookie({ name: "projectId", value: projectId });

    dispatch(getProject(projectId)).then((projectData) => {
        if (projectData.projectType) {
            dispatch(saveProjectType(projectData.projectType));
            setCookie({ name: "projectType", value: projectData.projectType });
        }
        
        const stagesData = [];
        const sectionData = projectData.stages;
        const allStages = [];
        const setStages = (data) => {
            if (data.stages) setStages(data.stages)
            else if (!data.stages) stagesData.push(data)
        }
        setStages(projectData.stages)

        const selectTasks = (stage) => {
            if (stage.stages) {
                selectTasks(stage.stages);
            } else if (stage.stages === null) {
                if (Array.isArray(stage.tasks)) {
                    stage.tasks.forEach((task) => {
                        task.selected = true;
                        task.subTasks.forEach((subTask) => {
                            subTask.selected = true;
                        });
                    });
                }
            }
        }


        const processStages = (stagesData) => {
            if (Array.isArray(stagesData)) {
                stagesData.forEach((stage) => {
                    if (stage.stages) {
                        processStages(stage.stages);
                    } else if (stage.stages === null && stage.tasks) {
                        stage.tasks.forEach((task, index) => {
                            (task.material || []).forEach((material, mIndex) => {
                                if (typeof material === 'string') {
                                    task.material[mIndex] = JSON.parse(material);
                                }
                            });

                            task.subTasks.forEach((subTask, subTaskIndex) => {
                                (subTask.material || []).forEach((material, mIndex) => {
                                    if (typeof material === 'string') {
                                        subTask.material[mIndex] = JSON.parse(material);
                                    }
                                });
                            });
                        });
                        allStages.push(stage);
                    }
                });
            }
        }

        if (projectData.stages !== null) {
            processStages(sectionData);
            sectionData.forEach(stage => {
                selectTasks(stage);
            })
        }
        dispatch(addProjectAction({
            res: projectData,
            stages: allStages,
            sectionData
        }))

    });
}

export const getProjectData = async ({ projectId, dispatch }) => {
    if (!projectId) return;

    let progressCostSubcontractor = 0, progressCostLabor = 0, progressCostMaterial = 0;
    let totalApprovedInvoices = 0, invoiceProgress = 0, forecastProfit = 0;
    let completedProgress = 0, totalClaimAmount = 0, totalRetentionAmount = 0;
    let showStageSelect = false;

    setCookie({ name: "projectId", value: projectId });

    const progressClaims = await dispatch(getProgressClaimList(projectId));

    progressClaims.forEach((claims) => {
        if (claims.progressClaimStatus) {
            totalClaimAmount += claims.claimAmount;
            totalRetentionAmount += claims.retentionAmount;
            totalApprovedInvoices++;
        }
    });
    const progressClaimCount = (Array.isArray(progressClaims) && progressClaims.length) || 0;
    const invoices = await dispatch(getInvoiceList(projectId));
    invoices.forEach((inv) => {
        if (inv.progressClaim) {
            invoiceProgress += inv.progressClaim.totalValue;
        }
    });

    const invoicesCount = (Array.isArray(invoices) && invoices.length) || 0;
    const { count: purchaseOrdersCount } = await dispatch(getPoCount(projectId));
    const { count: workOrdersCount } = await dispatch(getWorkOrderCount(projectId));


    dispatch(getProject(projectId)).then((projectData) => {
        // Save the project type to Redux and cookies
        if (projectData.projectType) {
            dispatch(saveProjectType(projectData.projectType));
            setCookie({ name: "projectType", value: projectData.projectType });
        }
        
        getLevels({ levelId: projectData.level, dispatch });
        // updateProjectData({ projectData: projectData, dispatch })

        let stagesData = projectData.stages || [];
        const sectionData = projectData.stages || [];
        const allStages = [];
        let totalTasks = 0;
        let calculations = {};
        let sectionCalculation = [];
        let taskCalculation = [];

        // Reset totals at the start of calculation
        let totalMaterialCostAllStages = 0;
        let totalLaborCostAllStages = 0;
        let totalSubContractorCostAllStages = 0;
        let totalMaterialSaleAllStages = 0;
        let totalLaborSaleAllStages = 0;
        let totalSubContractorSaleAllStages = 0;
        let overallProgressCostMaterial = 0;
        let overallProgressCostLabor = 0;
        let overallProgressCostSubcontractor = 0;
        let overallProgressTaskCount = 0;

        const selectTasks = (stage) => {
            if (stage.stages) {
                selectTasks(stage.stages);
            } else if (stage.stages === null) {
                if (Array.isArray(stage.tasks)) {
                    stage.tasks.forEach((task) => {
                        task.selected = true;
                        task.subTasks.forEach((subTask) => {
                            subTask.selected = true;
                        });
                    });
                }
            }
        }



        const processStages = (stagesData) => {
            if (Array.isArray(stagesData)) {
                stagesData.forEach((stage) => {
                    if (stage.stages) {
                        processStages(stage.stages);
                    } else if (stage.stages === null && stage.tasks) {
                        stage.tasks.forEach((task, index) => {
                            (task.material || []).forEach((material, mIndex) => {
                                if (typeof material === 'string') {
                                    task.material[mIndex] = JSON.parse(material);
                                }
                            });

                            task.subTasks.forEach((subTask, subTaskIndex) => {
                                (subTask.material || []).forEach((material, mIndex) => {
                                    if (typeof material === 'string') {
                                        subTask.material[mIndex] = JSON.parse(material);
                                    }
                                });
                            });
                        });
                        allStages.push(stage);
                    }
                });
            }
        }

        const calculateStageProgress = (stagesData) => {
            stagesData.forEach((stage) => {
                if (stage.stages) {
                    calculateStageProgress(stage.stages);
                } else if (stage.stages === null && stage.tasks) {
                    calculations = stageCalculation({ stages: [stage] });
                    sectionCalculation.push(calculations.stage);
                    taskCalculation.push(calculations.task);
                    if (stage.tasks.length > 0) {
                        const tasksActualBudget = stage.tasks.map((task) => {
                            const actualBudget = calculateActualBudget(task);
                            overallProgressTaskCount++;
                            return actualBudget;
                        });

                        const variations = Array.isArray(projectData.options) && projectData.options.length > 0 ?
                            projectData.options.filter(_ => _.proposal_status === 'APPROVED') : [];

                        variations.map((variation) => {
                            const actualBudget = calculateActualBudget(variation);
                            overallProgressTaskCount++;
                            tasksActualBudget.push(actualBudget);
                        });


                        const totalActualMaterialCost = tasksActualBudget.reduce(
                            (acc, budget) => acc + parseFloat(budget.actualMaterialCost || 0), 0
                        );
                        progressCostMaterial = (totalActualMaterialCost / calculations.material.sale) * 100;

                        const totalActualLaborCost = tasksActualBudget.reduce(
                            (acc, task) => acc + parseFloat(task.actualLaborCost || 0), 0
                        );
                        progressCostLabor = (totalActualLaborCost / calculations.labor.sale) * 100;

                        const totalActualSubContractorCost = tasksActualBudget.reduce(
                            (acc, budget) => acc + parseFloat(budget.actualSubContractorCost || 0), 0
                        );
                        progressCostSubcontractor = totalActualSubContractorCost ? (totalActualSubContractorCost / calculations.subcontractor.sale) * 100 : 0;

                        // Accumulate totals for all stages
                        totalMaterialCostAllStages += totalActualMaterialCost || 0;
                        totalLaborCostAllStages += totalActualLaborCost || 0;
                        totalSubContractorCostAllStages += totalActualSubContractorCost || 0;
                        totalMaterialSaleAllStages += calculations.material.sale || 0;
                        totalLaborSaleAllStages += calculations.labor.sale || 0;
                        totalSubContractorSaleAllStages += calculations.subcontractor.sale || 0;

                        stage.tasks.forEach((task) => {
                            completedProgress += parseFloat(task.percentageComplete) || 0;

                            let totalPercentage = 0;
                            task.subTasks.forEach((subTask) => {
                                totalPercentage += parseFloat(subTask.percentageComplete);
                            });

                            const taskPercentage = parseFloat(totalPercentage) / parseFloat(task.subTasks.length);
                            task.percentageComplete = taskPercentage;
                            task.totalProfit = calculations.task[task.id].total_profit;
                        });
                    }
                }
            });

            if (totalMaterialSaleAllStages > 0 && overallProgressTaskCount > 0) {
                overallProgressCostMaterial = (totalMaterialCostAllStages / totalMaterialSaleAllStages) * 100 / overallProgressTaskCount;
            }

            if (totalLaborSaleAllStages > 0 && overallProgressTaskCount > 0) {
                overallProgressCostLabor = (totalLaborCostAllStages / totalLaborSaleAllStages) * 100 / overallProgressTaskCount;
            }

            if (totalSubContractorSaleAllStages > 0 && overallProgressTaskCount > 0) {
                overallProgressCostSubcontractor = (totalSubContractorCostAllStages / totalSubContractorSaleAllStages) * 100 / overallProgressTaskCount;
            }
        }


        if (projectData.stages !== null) {
            processStages(sectionData);
            calculateStageProgress(sectionData, calculations);
            sectionData.forEach(stage => {
                selectTasks(stage);
            })
        }

        invoiceProgress = invoiceProgress ? (invoiceProgress / parseFloat(calculations.revised_cost || 1)) * 100 : 0;
        forecastProfit = forecastProfit ? parseFloat(calculations.revised_cost || 0) - forecastProfit : 0;
        completedProgress = completedProgress ? (completedProgress / (totalTasks * 100)) * 100 : 0;

        dispatch(addProjectAction({
            projectId: projectData.id,
            projectName: projectData.name,
            projectManagerName: idx(projectData, _ => _.manager.name),
            quoteType: projectData.quoteType,
            projectDescription: projectData.description,
            customerName: projectData.customer && projectData.customer.businessName,
            hasStages: projectData.hasStages,
            projectType: projectData.type,
            projectDataType: projectData.projectType,
            customerLevel: projectData.customer ? projectData.customer.level : "",
            contactData: projectData.customerContact,
            projectMarginValue: projectData.profitMarginValue || "",
            siteAddress: projectData.address,
            projectDueDate: projectData.dateOfCreation,
            attachmentArr: projectData.attachment,

            taskCost: calculations.task,
            stagesCost: calculations.stage,
            sectionCalculation,
            taskCalculation,

            showStageSelect,
            stagesData,
            totalTasks,
            stages: allStages,
            progressClaimCount,
            purchaseOrdersCount,
            workOrdersCount,
            invoicesCount,
            totalApprovedInvoices,
            invoiceProgress,
            forecastProfit,
            completedProgress,
            totalClaimAmount,
            totalRetentionAmount,
            progressCostSubcontractor,
            progressCostLabor,
            progressCostMaterial,
            calculations,
            sectionData,
            res: projectData,
            overallProgressCostMaterial,
            overallProgressCostLabor,
            overallProgressCostSubcontractor,
        }))

    });
}

export const updateProjectData = async ({ projectData, dispatch }) => {
    let projectId = projectData.id;
    let progressCostSubcontractor = 0, progressCostLabor = 0, progressCostMaterial = 0;
    let totalApprovedInvoices = 0, invoiceProgress = 0, forecastProfit = 0;
    let completedProgress = 0, totalClaimAmount = 0, totalRetentionAmount = 0;
    let showStageSelect = false;

    setCookie({ name: "projectId", value: projectId });

    const progressClaims = await dispatch(getProgressClaimList(projectId));

    progressClaims.forEach((claims) => {
        if (claims.progressClaimStatus) {
            totalClaimAmount += claims.claimAmount;
            totalRetentionAmount += claims.retentionAmount;
            totalApprovedInvoices++;
        }
    });
    const progressClaimCount = (Array.isArray(progressClaims) && progressClaims.length) || 0;
    const invoices = await dispatch(getInvoiceList(projectId));
    invoices.forEach((inv) => {
        if (inv.progressClaim) {
            invoiceProgress += inv.progressClaim.totalValue;
        }
    });

    const invoicesCount = (Array.isArray(invoices) && invoices.length) || 0;
    const { count: purchaseOrdersCount } = await dispatch(getPoCount(projectId));
    const { count: workOrdersCount } = await dispatch(getWorkOrderCount(projectId));

    const stagesData = [];
    const sectionData = projectData.stages;
    const allStages = [];
    let totalTasks = 0;
    let calculations = {};
    let sectionCalculation = [];
    let taskCalculation = [];

    // Reset totals at the start of calculation
    let totalMaterialCostAllStages = 0;
    let totalLaborCostAllStages = 0;
    let totalSubContractorCostAllStages = 0;
    let totalMaterialSaleAllStages = 0;
    let totalLaborSaleAllStages = 0;
    let totalSubContractorSaleAllStages = 0;
    let overallProgressCostMaterial = 0;
    let overallProgressCostLabor = 0;
    let overallProgressCostSubcontractor = 0;
    let overallProgressTaskCount = 0;

    const selectTasks = (stage) => {
        if (stage.stages) {
            selectTasks(stage.stages);
        } else if (stage.stages === null) {
            if (Array.isArray(stage.tasks)) {
                stage.tasks.forEach((task) => {
                    task.selected = true;
                    task.subTasks.forEach((subTask) => {
                        subTask.selected = true;
                    });
                });
            }
        }
    }

    const setStages = (data) => {
        if (data.stages) setStages(data.stages)
        else if (!data.stages) stagesData.push(data)
    }

    if (projectData.stages !== null) setStages(projectData.stages)


    const processStages = (stagesData) => {
        if (Array.isArray(stagesData)) {
            stagesData.forEach((stage) => {
                if (stage.stages) {
                    processStages(stage.stages);
                } else if (stage.stages === null && stage.tasks) {
                    stage.tasks.forEach((task, index) => {
                        (task.material || []).forEach((material, mIndex) => {
                            if (typeof material === 'string') {
                                task.material[mIndex] = JSON.parse(material);
                            }
                        });

                        task.subTasks.forEach((subTask, subTaskIndex) => {
                            (subTask.material || []).forEach((material, mIndex) => {
                                if (typeof material === 'string') {
                                    subTask.material[mIndex] = JSON.parse(material);
                                }
                            });
                        });
                    });
                    allStages.push(stage);
                }
            });
        }
    }

    const calculateStageProgress = (stagesData) => {
        stagesData.forEach((stage) => {
            if (stage.stages) {
                calculateStageProgress(stage.stages);
            } else if (stage.stages === null && stage.tasks) {
                calculations = stageCalculation({ stages: [stage] });
                sectionCalculation.push(calculations.stage);
                taskCalculation.push(calculations.task);
                if (stage.tasks.length > 0) {
                    const tasksActualBudget = stage.tasks.map((task) => {
                        const actualBudget = calculateActualBudget(task);
                        overallProgressTaskCount++;
                        return actualBudget;
                    });

                    const variations = Array.isArray(projectData.options) && projectData.options.length > 0 ?
                        projectData.options.filter(_ => _.proposal_status === 'APPROVED') : [];

                    variations.map((variation) => {
                        const actualBudget = calculateActualBudget(variation);
                        overallProgressTaskCount++;
                        tasksActualBudget.push(actualBudget);
                    });


                    const totalActualMaterialCost = tasksActualBudget.reduce(
                        (acc, budget) => acc + parseFloat(budget.actualMaterialCost || 0), 0
                    );
                    progressCostMaterial = (totalActualMaterialCost / calculations.material.sale) * 100;

                    const totalActualLaborCost = tasksActualBudget.reduce(
                        (acc, task) => acc + parseFloat(task.actualLaborCost || 0), 0
                    );
                    progressCostLabor = (totalActualLaborCost / calculations.labor.sale) * 100;

                    const totalActualSubContractorCost = tasksActualBudget.reduce(
                        (acc, budget) => acc + parseFloat(budget.actualSubContractorCost || 0), 0
                    );
                    progressCostSubcontractor = totalActualSubContractorCost ? (totalActualSubContractorCost / calculations.subcontractor.sale) * 100 : 0;

                    // Accumulate totals for all stages
                    totalMaterialCostAllStages += totalActualMaterialCost || 0;
                    totalLaborCostAllStages += totalActualLaborCost || 0;
                    totalSubContractorCostAllStages += totalActualSubContractorCost || 0;
                    totalMaterialSaleAllStages += calculations.material.sale || 0;
                    totalLaborSaleAllStages += calculations.labor.sale || 0;
                    totalSubContractorSaleAllStages += calculations.subcontractor.sale || 0;

                    stage.tasks.forEach((task) => {
                        completedProgress += parseFloat(task.percentageComplete) || 0;

                        let totalPercentage = 0;
                        task.subTasks.forEach((subTask) => {
                            totalPercentage += parseFloat(subTask.percentageComplete);
                        });

                        const taskPercentage = parseFloat(totalPercentage) / parseFloat(task.subTasks.length);
                        task.percentageComplete = taskPercentage;
                        task.totalProfit = calculations.task[task.id].total_profit;
                    });
                }
            }
        });

        if (totalMaterialSaleAllStages > 0 && overallProgressTaskCount > 0) {
            overallProgressCostMaterial = (totalMaterialCostAllStages / totalMaterialSaleAllStages) * 100 / overallProgressTaskCount;
        }

        if (totalLaborSaleAllStages > 0 && overallProgressTaskCount > 0) {
            overallProgressCostLabor = (totalLaborCostAllStages / totalLaborSaleAllStages) * 100 / overallProgressTaskCount;
        }

        if (totalSubContractorSaleAllStages > 0 && overallProgressTaskCount > 0) {
            overallProgressCostSubcontractor = (totalSubContractorCostAllStages / totalSubContractorSaleAllStages) * 100 / overallProgressTaskCount;
        }
    }

    if (projectData.stages !== null) {
        processStages(sectionData);
        calculateStageProgress(sectionData, calculations);
        sectionData.forEach(stage => {
            selectTasks(stage);
        })
    }

    invoiceProgress = invoiceProgress ? (invoiceProgress / parseFloat(calculations.revised_cost || 1)) * 100 : 0;
    forecastProfit = forecastProfit ? parseFloat(calculations.revised_cost || 0) - forecastProfit : 0;
    completedProgress = completedProgress ? (completedProgress / (totalTasks * 100)) * 100 : 0;


    dispatch(updateProjectAction({
        projectId: projectData.id,
        projectName: projectData.name,
        projectManagerName: idx(projectData, _ => _.manager.name),
        quoteType: projectData.quoteType,
        projectDescription: projectData.description,
        customerName: projectData.customer && projectData.customer.businessName,
        hasStages: projectData.hasStages,
        projectType: projectData.type,
        projectDataType: projectData.projectType,
        customerLevel: projectData.customer ? projectData.customer.level : "",
        contactData: projectData.customerContact,
        projectMarginValue: projectData.profitMarginValue || "",
        siteAddress: projectData.address,
        projectDueDate: projectData.dateOfCreation,
        attachmentArr: projectData.attachment,

        taskCost: calculations.task,
        stagesCost: calculations.stage,
        sectionCalculation,
        taskCalculation,

        showStageSelect,
        stagesData,
        totalTasks,
        stages: allStages,
        progressClaimCount,
        purchaseOrdersCount,
        workOrdersCount,
        invoicesCount,
        totalApprovedInvoices,
        invoiceProgress,
        forecastProfit,
        completedProgress,
        totalClaimAmount,
        totalRetentionAmount,
        progressCostSubcontractor,
        progressCostLabor,
        progressCostMaterial,
        calculations,

        sectionData,
        res: projectData,
        overallProgressCostMaterial,
        overallProgressCostLabor,
        overallProgressCostSubcontractor,
    }))
}

export const getLevels = async ({ levelId, dispatch }) => {
    const level = await dispatch(getLevel(levelId))

    const labors = [];
    level.hourlyCost && level.hourlyCost.forEach((cost) => {
        labors.push({
            ...cost,
            calloutCost: level.calloutCost,
            travelCost: level.travelCost,
        });
    });

    dispatch(addLevelAction(labors))
};

export const calculateActualBudget = (task = {}) => {
    // let actualSubContractorCost = 0;
    const actualMaterialCost =
        (Array.isArray(task.materialPoCost) &&
            task.materialPoCost.reduce((acc, _material) => {
                let materialBudget = 0;
                if (_material && _material.budget && "PO" in _material.budget) {
                    materialBudget += (Array.isArray(_material.budget["PO"]) &&
                        _material.budget["PO"].reduce((acc, poBudget) =>
                            acc + parseFloat(poBudget.amountPaid),
                            0
                        )) || 0;
                }
                if (_material && _material.budget && "WPO" in _material.budget) {
                    materialBudget += (Array.isArray(_material.budget["WPO"]) &&
                        _material.budget["WPO"].reduce((acc, poBudget) =>
                            acc + parseFloat(poBudget.amountPaid),
                            0
                        )) || 0;
                }
                return acc + materialBudget;
            }, 0)) || 0;
    const actualLaborCost = task.laborCost ? parseFloat(task.laborCost) || 0 : 0;
    const actualSubContractorCost = (Array.isArray(task.subContractorInvoiceCost) &&
        task.subContractorInvoiceCost.reduce((acc, _invoices) => {
            return acc + parseFloat(_invoices.amountPaid || 0);
        }, 0)) || 0;

    return { actualMaterialCost, actualLaborCost, actualSubContractorCost };
};